import type { CSSObject } from '@mantine/core';
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	root: {
		flexGrow: '1 !important' as CSSObject['flexGrow'],
	},
	input: {
		backgroundColor: theme.other.getColor('surface/secondary/default'),
		height: theme.other.space[5],
		lineHeight: theme.other.typography.lineHeight.text.sm,
		padding: `${theme.spacing['3xs']} ${theme.spacing['3xs']} ${theme.spacing['3xs']} ${theme.spacing.sm}`,
		borderRadius: theme.radius.sm,
		borderWidth: 0,
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/secondary/hover'),
		},
		'&:focus': {
			backgroundColor: theme.other.getColor('surface/secondary/active'),
			borderColor: theme.other.neutralColors.white,
			boxShadow: `0px 0px 0px 2px ${theme.other.getColor('border/emphasis/default')}`,
		},
		'&:active': {
			backgroundColor: theme.other.getColor('surface/secondary/active'),
			borderColor: theme.other.neutralColors.white,
			boxShadow: `0px 0px 0px 2px ${theme.other.getColor('border/emphasis/default')}`,
		},
	},
}));
